export default __webpack_public_path__ + "static/media/A_Accessories.f082f419.jpg";